import { render, staticRenderFns } from "./ShipmentAddressTags.vue?vue&type=template&id=0fee7669&scoped=true"
import script from "./ShipmentAddressTags.vue?vue&type=script&lang=js"
export * from "./ShipmentAddressTags.vue?vue&type=script&lang=js"
import style0 from "./ShipmentAddressTags.vue?vue&type=style&index=0&id=0fee7669&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fee7669",
  null
  
)

export default component.exports